import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import { getTrainers, deleteTrainer } from "../../services/trainerService";
import "./Trainers.css";
import { doc, updateDoc, increment } from "firebase/firestore";
import { db, auth } from "../../firebase/config";

export default function Trainers() {
  const navigate = useNavigate();

  const [trainers, setTrainers] = useState([]);

  useEffect(() => {
    loadTrainers();
  }, []);

  const loadTrainers = async () => {
    const data = await getTrainers();
    setTrainers(data);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete trainer?")) return;

    try {
      await deleteTrainer(id);

      await updateDoc(doc(db, "gyms", auth.currentUser.uid), {
        totalTrainers: increment(-1),
      });

      loadTrainers();
    } catch (error) {
      console.error(error);
      alert("Failed to delete trainer");
    }
  };

  return (
    <DashboardLayout>
      <div className="trainers-page">
        <div className="trainers-header">
          <div>
            <h1>Trainer Management</h1>
            <p style={{ fontWeight: "bold", color: "white" }}>
              Manage gym trainers, specializations, salaries and availability.
            </p>
          </div>

          <button
            className="add-trainer-btn"
            onClick={() => navigate("/trainers/add")}
          >
            + Add Trainer
          </button>
        </div>

        <div className="trainer-stats">
          <div className="trainer-stat-card">
            <h4>Total Trainers</h4>
            <h2>{trainers.length}</h2>
          </div>

          <div className="trainer-stat-card active-card">
            <h4>Active Trainers</h4>
            <h2>
              {trainers.filter((trainer) => trainer.status === "Active").length}
            </h2>
          </div>

          <div className="trainer-stat-card salary-card">
            <h4>Total Salary</h4>
            <h2>
              ₹
              {trainers.reduce(
                (sum, trainer) => sum + Number(trainer.salary || 0),
                0,
              )}
            </h2>
          </div>
        </div>

        <div className="trainers-table-card">
          <table className="member-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Specialization</th>
                <th>Salary</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {trainers.length > 0 ? (
                trainers.map((trainer) => (
                  <tr key={trainer.id}>
                    <td>{trainer.name}</td>

                    <td>{trainer.phone}</td>

                    <td>{trainer.email}</td>

                    <td>
                      <span className="specialization-pill">
                        {trainer.specialization}
                      </span>
                    </td>

                    <td className="salary-cell">₹{trainer.salary}</td>

                    <td>
                      <span
                        className={
                          trainer.status === "Active"
                            ? "trainer-active"
                            : "trainer-inactive"
                        }
                      >
                        {trainer.status}
                      </span>
                    </td>

                    <td>
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(trainer.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7">No Trainers Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
